
export class Cotizacion{

  constructor(
  public pair_id?: number,
  public mount_sell?: string,
  public mount_buy?: string
  ){}
}
